import React, { Component } from 'react'

import isEqual from 'lodash/isEqual'
import omit from 'lodash/omit'
import PropTypes from 'prop-types'
import ReactPixel from 'react-facebook-pixel'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import BlankCard from '../../../components/ui/cards/BlankCard'
import LottieLoader from '../../../components/ui/lotties/LottieLoader'
import NavBar from '../../../components/ui/navigation/NavBar'
import store from '../../../store/configureStore'
import { RESET } from '../../../store/rootReducer'
import * as currentUserDuck from '../../../store/shared/currentUserDuck'
import { sendUserData } from '../../../utils/analyticsHelpers/'
import sendFullStoryEvent from '../../../utils/analyticsHelpers/sendFullStoryEvent'
import fullstory from '../../../utils/constants/fullstory'
import intercom from '../../../utils/intercom/intercomUtils'
import notification from '../../../utils/notifications/notificationsUtils'
import paramsUtils from '../../../utils/routing/params'
import * as insTokenDuck from '../Onboarding/insTokenDuck'

const { eventNames } = fullstory

class UnauthenticatedWelcomeIndex extends Component {
  static propTypes = {
    currentUserSuccess: PropTypes.func.isRequired,
    history: PropTypes.any.isRequired,
    retrieveUserProfile: PropTypes.func.isRequired,
    validateInsToken: PropTypes.func.isRequired,
    insTokenError: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      fullName: '',
    }

    this.updateState = updates => this.setState(updates)

    this.redirectWithIUserData = user => {
      this.props.history.push({
        pathname: '/onboarding',
        search: this.props.history.location.search,
      })

      // Send user data to intercom
      // Create new hmac whenever we first send the user data
      intercom.createNewHMAC(user._id)
      intercom.intercomBoot({
        user_id: user._id,
        email: user.email,
        createdAt: user.createdAt,
        updatedAt: user.updatedAt,
        insToken: user.insToken ? user.insToken : null,
        stripe_plan_id: user.stripe_plan_id ? user.stripe_plan_id : null,
        stripe_needs_updated_payment: user.stripe_needs_updated_payment,
        stripe_plan_id_before_cancellation: user.stripe_plan_id_before_cancellation,
        ...user.info,
        ...omit(user.profile, ['liSummary']),
        interests: user.interests.join(', '),
        lastLogin: user.lastLogin,
        accessAllowed: user.accessAllowed,
        isSystemAdministrator: user.isSystemAdministrator,
      })

      // Send user data to facebook-pixel
      ReactPixel.trackCustom('Social Login', {
        email: user.email,
        createdAt: user.createdAt,
        ...user.profile,
      })
    }
  }

  componentDidMount() {
    const { history } = this.props
    const queryParams = paramsUtils.getObjectSimply(history.location.search)
    this.updateState(queryParams)
    this.props.retrieveUserProfile(queryParams.token)
  }

  componentDidUpdate(prevProps) {
    const {
      currentUser: prevCurrentUser,
      insTokenError: prevInstokenError,
      insToken: prevInsToken,
    } = prevProps
    const { currentUser, insTokenError, insToken } = this.props

    if (prevInsToken !== insToken && !insTokenError) {
      this.redirectWithIUserData(currentUser)
    }

    const { newSignup } = this.state

    if (!isEqual(prevInstokenError, insTokenError) && insTokenError) {
      notification.showErrorNotification(insTokenError)
      store.dispatch({ type: RESET })
    }

    if (!prevCurrentUser && currentUser) {
      this.props.currentUserSuccess(currentUser)
      if (newSignup) {
        sendUserData(currentUser)
        sendFullStoryEvent(eventNames.signup)
      }

      this.props.validateInsToken(currentUser)
    }
  }

  render() {
    const { fullName } = this.state

    return (
      <div>
        <NavBar noActions />
        <div className="container">
          <div className="max-600">
            <BlankCard className="text-center" delay={1.25} style={{ marginTop: 80 }}>
              <div>
                <h1 style={{ fontWeight: '800' }}>Hey {fullName}, welcome to Steppingblocks!</h1>
                <h6 className="text-muted">We're logging you in</h6>
                <LottieLoader noMessage animationName="GEARS" isReady={false} loadingTime={2000} />
              </div>
            </BlankCard>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      currentUserSuccess: currentUserDuck.currentUserSuccess,
      retrieveUserProfile: currentUserDuck.performRetrieveUserProfile,
      validateInsToken: insTokenDuck.performValidateInsToken,
    },
    dispatch,
  )
const mapStateToProps = _state => ({
  currentUser: _state.currentUser.user,
  insTokenError: _state.insToken.error,
  insToken: _state.insToken.insToken,
})

export default connect(mapStateToProps, mapDispatchToProps)(UnauthenticatedWelcomeIndex)



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Welcome/UnauthenticatedWelcomeIndex.js